import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

  @Input() mensajeComponente!: string;
  mensajeAlerta: string = '';

  constructor() { }

  ngOnInit(): void {
    this.mensajeAlerta = this.mensajeComponente;
  }
}
